import { HotspotMixinListener } from '@owc-types/Hotspot';
import {
  getHotspotStateConnection,
  initializeHotspotState,
  subscribeHotspotState,
  unsubscribeHotspotState,
} from '../Store/hotspot';

const setActiveHotspotId = async (hotspotId: string, activeHotspotItemId: string): Promise<void> => {
  const connection = await getHotspotStateConnection();
  connection.setActiveHotspot(hotspotId, activeHotspotItemId);
};

const showHotspotTabs = async (hotspotId: string): Promise<void> => {
  const connection = await getHotspotStateConnection();
  connection.showTabsForHotspot(hotspotId);
};

const hideHotspotTabs = async (hotspotId: string): Promise<void> => {
  const connection = await getHotspotStateConnection();
  connection.hideTabsForHotspot(hotspotId);
};

const addHotspotChangeListener = (id: string, listener: HotspotMixinListener): void => {
  subscribeHotspotState(id, listener);
};

const removeHotspotChangeListener = (id: string, listener: HotspotMixinListener): void => {
  unsubscribeHotspotState(id, listener);
};

export default {
  mounted() {
    initializeHotspotState();
  },
  methods: {
    setActiveHotspotId,
    showHotspotTabs,
    hideHotspotTabs,
    addHotspotChangeListener,
    removeHotspotChangeListener,
  },
};
